import script from "./xrj.vue?vue&type=script&setup=true&lang=js"
export * from "./xrj.vue?vue&type=script&setup=true&lang=js"

import "./xrj.vue?vue&type=style&index=0&id=e778d50e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e778d50e"]])

export default __exports__